import React from 'react';
import { usePlacesWidget } from 'react-google-autocomplete';
import { useTranslation } from 'react-i18next';
import { colors } from '@guryou/colors';
import { CustomButton, FlexColumn, FlexRow, MediumText } from '@guryou/html-components';
import RoomOutlinedIcon from '@material-ui/icons/RoomOutlined';
import SearchIcon from '@material-ui/icons/Search';
import SearchField from './SearchField';
import ToggleSwitch from './toggleSwitch';

const Filters = ({ width, tabletWidth, onChange, switchValue, handleKeywordChange, handleAddressChange, onSubmit }) => {
  const { t } = useTranslation();

  const { ref } = usePlacesWidget({
    apiKey: process.env.REACT_APP_GOOGLE_MAPS_API_TOKEN,
    onPlaceSelected: place => handleAddressChange(place),
  });

  const handleAddressChangeNotGoogleAutoComplete = e => {
    handleAddressChange(e.target?.value);
  };

  return (
    <section className="relative sm:rounded-lg">
      <div class="max-w-screen-xl px-4 mx-auto lg:px-12 w-full">
        <div>
          <div class="flex flex-col items-center justify-between p-4 space-y-3 md:flex-row md:space-y-0 md:space-x-4">
            <div class="w-full md:w-1/2">
              <div class="inline-flex rounded-md shadow-sm w-full" role="group">
                <button
                  type="button"
                  class={`
                    w-full px-4 py-2 text-sm font-medium
                    bg-[${switchValue === 'C' ? colors.mandy : 'white'}] 
                    text-${switchValue === 'C' ? 'white' : 'gray-900'}
                    border border-gray-200 rounded-s-lg hover:bg-[${colors.mandy}] 
                    hover:text-white focus:z-10`}
                  onClick={() => {
                    onChange('C');
                  }}
                >
                  {t(`GENERAL.centers`)}
                </button>
                <button
                  type="button"
                  class={`w-full px-4 py-2 text-sm font-medium
                    bg-[${switchValue === 'P' ? colors.mandy : 'white'}] 
                    text-${switchValue === 'P' ? 'white' : 'gray-900'}
                    border border-gray-200 rounded-e-lg hover:bg-[${colors.mandy}] 
                    hover:text-white focus:z-10`}
                  onClick={() => {
                    onChange('P');
                  }}
                >
                  {t(`GENERAL.professionals`)}
                </button>
              </div>
            </div>
            <div class="w-full md:w-1/2">
              <label for="simple-search" class="sr-only">
                {t('CONTENT.keyword')}
              </label>
              <div class="relative w-full">
                <div class="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                  <svg aria-hidden="true" class="w-5 h-5 text-gray-500" fill="currentColor" viewbox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                    <path
                      fill-rule="evenodd"
                      d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z"
                      clip-rule="evenodd"
                    />
                  </svg>
                </div>
                <input
                  type="text"
                  id="simple-search"
                  class="block w-full p-2 pl-10 text-sm text-gray-900 border border-gray-300 rounded-lg bg-gray-50 focus:ring-primary-500 focus:border-primary-500"
                  placeholder={t('CONTENT.keyword')}
                  name="keyword"
                  onChange={handleKeywordChange}
                  inputKey="keyword"
                />
              </div>
            </div>
            <div class="w-full md:w-1/2">
              <label for="simple-search" class="sr-only">
                {t('CONTENT.nearby')}
              </label>
              <div class="relative w-full">
                <div class="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                  <svg
                    class="w-6 h-6 text-gray-500"
                    aria-hidden="true"
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    fill="none"
                    viewBox="0 0 24 24"
                  >
                    <path
                      stroke="currentColor"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M12 13a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z"
                    />
                    <path
                      stroke="currentColor"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M17.8 13.938h-.011a7 7 0 1 0-11.464.144h-.016l.14.171c.1.127.2.251.3.371L12 21l5.13-6.248c.194-.209.374-.429.54-.659l.13-.155Z"
                    />
                  </svg>
                </div>
                <input
                  type="text"
                  id="simple-search"
                  class="block w-full p-2 pl-10 text-sm text-gray-900 border border-gray-300 rounded-lg bg-gray-50 focus:ring-primary-500 focus:border-primary-500"
                  placeholder={t('CONTENT.nearby')}
                  ref={ref}
                  name="address"
                  inputKey="address"
                  onChange={handleAddressChangeNotGoogleAutoComplete}
                />
              </div>
            </div>
            <div class="w-full md:w-1/6">
              <button
                type="button"
                class={`w-full h-full text-white bg-[${colors.mandy}] hover:bg-primary-800 font-medium rounded-lg text-sm px-4 lg:px-5 py-2 lg:py-2.5 mr-2 focus:outline-none`}
                onClick={onSubmit}
              >
                {t('YF_SEARCH.searchFor')}
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );

  // return (
  //   <FlexColumn alignItems="center" xs={12} marginTop={2}>
  //     <MediumText fontSize={width < 450 ? '1.1rem' : '2rem'} marginTop={1} marginBottom={width < tabletWidth ? 2 : 0}>
  //       {t('YF_SEARCH.whatAreYouLookingFor')}
  //     </MediumText>
  //     <FlexRow justifyContent="center">
  //       <ToggleSwitch width={width} tabletWidth={tabletWidth} onChange={onChange} switchValue={switchValue} />
  //     </FlexRow>
  //     <Wrapper width={width} alignItems="start" marginTop={width < tabletWidth ? 7 : 10} tabletWidth={tabletWidth} up={false}>
  //       <SearchField
  //         name="keyword"
  //         inputKey="keyword"
  //         placeholder={t('CONTENT.keyword')}
  //         marginBottom={width < tabletWidth ? 20 : 0}
  //         startAndor={<SearchIcon style={{ marginRight: '10px' }} />}
  //         width={width}
  //         onChange={handleKeywordChange}
  //       />
  //       <SearchField
  //         inputKey="address"
  //         name="address"
  //         placeholder={t('CONTENT.nearby')}
  //         startAndor={<RoomOutlinedIcon style={{ marginRight: '10px' }} />}
  //         marginLeft={width < tabletWidth ? '0' : '20px'}
  //         marginBottom={width < tabletWidth ? 20 : 0}
  //         width={width}
  //         inputRef={ref}
  //       />
  //       <CustomButton
  //         margin={0}
  //         marginLeft={width < 650 ? 'auto' : 5}
  //         marginRight={width < 650 && 'auto'}
  //         marginTop={width < 900 && '30px'}
  //         backgroundColor={colors.mineShaft}
  //         width="140px"
  //         fontSize="0.9rem"
  //         fontWeight={600}
  //         paddingTop={5}
  //         paddingBottom={5}
  //         boxShadow="0px 0px 10px rgba(0, 0, 0, 0.3)"
  //         color={colors.white}
  //         onClick={onSubmit}
  //       >
  //         {t('YF_SEARCH.searchFor')}
  //       </CustomButton>
  //     </Wrapper>
  //   </FlexColumn>
  // );
};

const Wrapper = ({ children, width, parent = false, tabletWidth, up, ...rest }) => {
  let mobileSizeUp;

  let mobileSizeDown;

  if (width < 1500) {
    mobileSizeUp = 3.1;
    mobileSizeDown = 11;
  }

  if (width < 1200) {
    mobileSizeUp = 3.5;
    mobileSizeDown = 11;
  }

  if (width > 1500) {
    mobileSizeUp = 2.1;
    mobileSizeDown = 11;
  }

  if (width < 650) {
    mobileSizeUp = 9.2;
    mobileSizeDown = 11;
  }

  return width < tabletWidth ? (
    <FlexColumn xs={!parent && 12} {...rest}>
      {children}
    </FlexColumn>
  ) : (
    <FlexRow
      xs={!parent && up ? mobileSizeUp : mobileSizeDown}
      textAlign="center"
      alignItems="center"
      justifyContent={up ? 'flex-start' : 'center'}
      {...rest}
    >
      {children}
    </FlexRow>
  );
};

export default Filters;
